import cn from 'clsx';
import Image from 'next/image';
import { FC } from 'react';

import s from './LookUpRequestView.module.scss';

import LockIcon from '@/assets/illust-icons/fill-lock3.svg';
import ZeroMoney from '@/assets/illust-icons/fill-zero-money.svg';

interface Props {
  isShow: boolean;
  cardIndex: number;
}
type ContentCardProps = Props;

const ContentCard: FC<ContentCardProps> = ({ isShow, cardIndex }) => {
  const titles = ['이용료 부담은 덜어두세요', '수임 중인 세무사가 있더라도', '사후 관리도 걱정마세요'];
  const subTitles = ['환급받기 전까지\n어떤 비용도 발생하지 않아요', '세금 환급은 특화된 전문가의\n도움이 필요해요', '책임환불제로 더욱 안전해요'];

  let image = <ZeroMoney height={70} width={156} />;
  switch (cardIndex) {
    case 1:
      image = (
        <div className="flex justify-center">
          <Image src={'/images/incomeTaxRefund/img_cancel-cpa2.png'} width={169} height={70} alt={'cpa'} />
        </div>
      );
      break;
    case 2:
      image = <LockIcon width={103} height={82} />;
      break;
    default:
      break;
  }

  return (
    <div
      className={cn('absolute flex w-full rounded-[20px]', {
        [`${s.fade_in_up}`]: isShow,
        [`${s.fade_out}`]: !isShow,
        [`${s.content0}`]: cardIndex === 0,
        [`${s.content1}`]: cardIndex === 1,
        [`${s.content2}`]: cardIndex === 2
      })}
    >
      <div className="flex w-full flex-col items-center justify-center gap-2 p-6">
        <div className="sub-title-13 text-violet-600">{titles[cardIndex]}</div>
        <div className="headline-16 mb-5 whitespace-pre-line text-center text-gray-800">{subTitles[cardIndex]}</div>
        {image}
      </div>
    </div>
  );
};

export default ContentCard;
